import { styled, TextField, TextFieldProps } from "@mui/material";

export const CustomTextField = styled(TextField)<TextFieldProps>`
  width: 100%;

  .MuiInputBase-root {
    background-color: transparent;
    border-radius: 10px;
    color: #ABAFB1;
  }

  .MuiOutlinedInput-notchedOutline {
    border: 1px solid #ABAFB1;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #ABAFB1;
  }

  .MuiInputLabel-root {
    color: #ABAFB1;
  }

  .MuiInputLabel-root.Mui-focused {
    color: #ABAFB1;
  }

  input {
    color: #ABAFB1;
  }

  input::placeholder {
    color: #ABAFB1;
    opacity: 1;
  }

  /* Fix for Autocomplete white background */
  .MuiAutocomplete-inputRoot {
    background-color: transparent !important;
  }
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #202546 inset !important;
    box-shadow: 0 0 0 1000px #202546 inset !important;
    transition: background-color 5000s ease-in-out 0s;
      -webkit-text-fill-color: #ABAFB1 !important;

    border: none !important; 
    border-radius: 0;
  }
      /* 🔽 Icon color fix */
  .MuiSvgIcon-root {
    color: #ABAFB1 !important;
  }

  /* Optional: if using InputAdornment for icons */
  .MuiInputAdornment-root {
    color: #ABAFB1 !important;
  }
`;